export default "__VITE_ASSET__Cji7V6q___"